export default __webpack_public_path__ + "6219b1722f65420790c54c21bb6a27bd.png";